import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import loginIntegrations from './integrations';
import { Integration } from 'components/auth/Integration';

export const Or = () => <div className="or" data-text="lub" />;

export default ({ OAuthIntegrations, otherIntegrations, registrationEnabled }) => (
	<Fragment>
		{OAuthIntegrations.length > 0 && (
			<div className="integrations--oauth">
				{OAuthIntegrations.map(integration => Integration(loginIntegrations, integration, 'login'))}
				{otherIntegrations.length > 0 && <Or />}
			</div>
		)}
		<div className="integrations--other">
			{otherIntegrations.map((integration, index) => (
				<Fragment key={index}>
					{Integration(loginIntegrations, integration)}
					{index < otherIntegrations.length - 1 && <Or />}
				</Fragment>
			))}
		</div>
		{registrationEnabled && (
			<p>
				<FormattedMessage id="auth.login.navigate.not-account-yet" tagName={React.Fragment} />{' '}
				<NavLink to="/auth/register?disableLandingPage">
					<FormattedMessage id="auth.login.navigate.register" tagName={React.Fragment} />
				</NavLink>
			</p>
		)}
	</Fragment>
);
